import React from "react";
import {
    Button,
    TextField,
    Grid,
    Card,
    Container,
    CardContent,
    CardHeader,
} from "@mui/material";

export default function SignUp() {
    // const [error, setError] = React.useState("");
    const error = "";
    const handleSubmit = async () => {};

    return (
        <Container component="main" maxWidth="xs">
            <div className="banner">
                <img src="/img/logo-centric-38.png" alt="" />
            </div>
            <div className="form auth-card-container signup">
                <form>
                    <Card className="card" data-cy="card_sign-up">
                        <Grid item xs={12}>
                            <CardHeader>
                                <div className="app-icon">
                                    <img
                                        src="https://cdn.premierit.com/images/logos/cent/logo-cent-80.png"
                                        alt="Centric"
                                    />
                                </div>
                            </CardHeader>
                            <CardContent>
                                <div className="form-title">
                                    Sign in to continue to:
                                </div>
                                <div className="form-row">
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email"
                                        name="email"
                                        autoComplete="email"
                                        autoFocus
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="name"
                                        label="Full name"
                                        name="name"
                                        autoComplete="Full name"
                                        autoFocus
                                    />
                                </div>
                                <div className="form-action">
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        disableElevation={true}
                                    >
                                        Sign Up
                                    </Button>
                                </div>
                                {error && (
                                    <div className="form-row-last">
                                        <div className="alert alert-error">
                                            {error}
                                        </div>
                                    </div>
                                )}
                            </CardContent>
                        </Grid>
                    </Card>
                </form>
            </div>
            <footer className="footer">
                <div className="footer-content">
                    <ul className="footer-links">
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://docs.premierit.com/policies/web/privacy-notice.html"
                            >
                                Privacy
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://docs.premierit.com/policies/web/accessibility-statement.html"
                            >
                                Accessibility
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://docs.premierit.com/policies/web/terms-of-use.html"
                            >
                                Terms of use
                            </a>
                        </li>
                    </ul>
                    <div className="copyright">
                        Copyright &copy; 2021{" "}
                        <a
                            href="https://www.premierit.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Premier IT
                        </a>
                    </div>
                </div>
            </footer>
        </Container>
    );
}
